import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import ArrowRight from '../icons/ArrowRight';
import { useTranslation } from 'react-i18next';
import WhyChooseOurPms from '../components/WhyChooseOurPms';
import useLanguagePrefix from '../LanguagePrefix';
import DemoRequestForm from '../components/pricing/DemoRequestForm';
import ExpandableCard from '../components/ExpandableCard';
import './NotFound.css';

function NotFound() {
    const { t } = useTranslation();
    const langPrefix = useLanguagePrefix();
    
    useEffect(() => {
        document.title = "Page Not Found - Prostay";
        // DON'T change the URL - that's what was causing the redirect!
    }, []);

    return (
        <div>
            <Helmet>
                <title>Page Not Found - Prostay</title>
                <meta name="robots" content="noindex" />
            </Helmet>

            <div className='not-found d-flex mb-4 justify-content-center'>
                <div className='page-content d-flex flex-column align-items-center' style={{ backgroundColor: "#fff", marginTop: 100, position: 'relative' }}>
                    <img src="/images/404.svg" alt="Not Found" style={{ maxWidth: '100%' }} />
                    <a className='light-blue-filled-btn-small' href={`${langPrefix}/`}>
                        Go Home
                        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.33333 1.33301L13 5.99967M13 5.99967L8.33333 10.6663M13 5.99967H1" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default NotFound;